export function topBadgeClass(status) {
  if (!status) return "badge bg-secondary";
  const s = String(status).toLowerCase();
  if (s === "draft") return "badge bg-warning text-dark";
  if (s === "failed") return "badge bg-danger";
  return "badge bg-success";
}

export function badgeClass(status) {
  if (!status) return "badge bg-secondary";
  const s = String(status).toLowerCase();
  if (s === "completed") return "badge bg-success";
  if (s === "uploaded" || s === "pending") return "badge bg-warning text-dark";
  if (s === "failed") return "badge bg-danger";
  return "badge bg-secondary";
}

export function prettyType(t) {
  return t ? String(t).replace(/_/g, " ") : "—";
}

export function displayFilename(m) {
  const s = String(m?.status || "").toLowerCase();
  if (s !== "completed") return "—";
  return m?.original_filename || m?.filename || "—";
}
